module.exports = __webpack_public_path__ + "fonts/MaterialDesignIcons.4b19259.eot";